import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 타입 정의
export interface Profile {
  id: string;
  email: string;
  username: string;
  user_type: 'fan' | 'creator' | 'admin';
  full_name?: string;
  avatar_url?: string;
  cover_url?: string;
  bio?: string;
  category?: string;
  balance: number;
  total_earned: number;
  total_spent: number;
  subscriber_count: number;
  status: 'active' | 'suspended' | 'pending';
  invite_code?: string;
  created_at: string;
  updated_at: string;
}

export interface Subscription {
  id: string;
  fan_id: string;
  creator_id: string;
  level: number;
  level_name: string;
  price: number;
  status: 'active' | 'cancelled' | 'expired';
  started_at: string;
  expires_at?: string;
  created_at: string;
  updated_at: string;
}

export interface Transaction {
  id: string;
  user_id: string;
  type: 'charge' | 'subscription' | 'tip' | 'withdrawal' | 'refund';
  amount: number;
  balance_after: number;
  description?: string;
  related_user_id?: string;
  related_user_name?: string;
  status: 'pending' | 'completed' | 'failed' | 'cancelled';
  metadata?: any;
  created_at: string;
}

export interface Post {
  id: string;
  creator_id: string;
  images: string[];
  content: string;
  level: number;
  level_name: string;
  likes_count: number;
  comments_count: number;
  status: 'draft' | 'published' | 'archived';
  created_at: string;
  updated_at: string;
}

export interface Message {
  id: string;
  sender_id: string;
  receiver_id: string;
  text: string;
  is_read: boolean;
  created_at: string;
}
